class FacetsDisplaySwitcher extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const grid = document.querySelector("#ProductGridContainer");
        const buttons = this.querySelectorAll(
            ".facets__grid_display_container"
        );

        buttons.forEach((btn) =>
            btn.addEventListener("click", () => {
                buttons.forEach((btn) =>
                    btn.setAttribute("data-active", false)
                );
                btn.setAttribute("data-active", true);
                grid.setAttribute(
                    "data-display",
                    btn.getAttribute("data-display")
                );
            })
        );
    }
}

customElements.define("facets-display-switcher", FacetsDisplaySwitcher);
